module.exports = __webpack_public_path__ + "img/robot_gif2.3955ce63.3955ce63.gif";